import React from 'react';
import { BOOST_MAX_RELEASE_DELAY_SEC } from '../../../utils/ruleSamplingBoost';

const seconds = (value) => (value === null || value === undefined ? '—' : `${value} с`);

/**
 * Текущий интервал опроса камеры (GET sampling-effective). Только справка:
 * помогает выбрать интервал ускорения, ничего не сохраняет.
 */
const CameraSamplingNow = ({ effective }) => {
  if (!effective || effective.state === 'idle') return null;

  return (
    <div className="vio-sampling-now">
      <p className="vio-drawer-section-title">Камера сейчас</p>
      {effective.state === 'loading' && <p className="vio-field-hint">Загружаем…</p>}
      {effective.state === 'error' && (
        <p className="vio-field-hint">Не удалось узнать текущий интервал камеры.</p>
      )}
      {effective.state === 'ready' && (
        <>
          <div className="vio-readonly-grid vio-sampling-now-grid">
            <div>
              <div className="vio-readonly-label">Базовый интервал</div>
              <div className="vio-readonly-value">{seconds(effective.data?.base_interval_sec)}</div>
            </div>
            <div>
              <div className="vio-readonly-label">Интервал сейчас</div>
              <div className="vio-readonly-value">{seconds(effective.data?.effective_interval_sec)}</div>
            </div>
            <div>
              <div className="vio-readonly-label">Минимально допустимый интервал</div>
              <div className="vio-readonly-value">{seconds(effective.data?.safety_min_interval_sec)}</div>
            </div>
          </div>
          {effective.data?.boosted && <p className="vio-field-hint">Ускорение сейчас действует</p>}
        </>
      )}
    </div>
  );
};

/**
 * Ускорение детекций (Sampling Boost, ТЗ №39). Не входит в core-правило:
 * сохраняется отдельным PUT/DELETE после того, как у правила есть rule_id.
 * Состояние формы — { enabled, requestedIntervalSec, releaseDelaySec }.
 *
 * loadState: ready | loading | error — у существующего правила конфигурация
 * сначала читается; пока она не прочитана, менять её нельзя, иначе
 * сохранение перезаписало бы неизвестную настройку.
 */
const SamplingBoostFields = ({
  value,
  onChange,
  error = '',
  disabled = false,
  loadState = 'ready',
  effective = null,
  idPrefix = 'vio',
}) => {
  const enabled = Boolean(value?.enabled);
  const locked = disabled || loadState !== 'ready';

  return (
    <fieldset className="vio-rule-extra">
      <div className="form-check form-switch vio-switch">
        <input
          id={`${idPrefix}-boost-enabled`}
          className="form-check-input"
          type="checkbox"
          role="switch"
          checked={enabled}
          disabled={locked}
          onChange={(event) => onChange({ ...value, enabled: event.target.checked })}
        />
        <label className="form-check-label vio-switch-label" htmlFor={`${idPrefix}-boost-enabled`}>
          Ускорение детекций
        </label>
      </div>
      {loadState === 'loading' && <p className="vio-field-hint">Загружаем настройки ускорения…</p>}
      {loadState === 'error' && (
        <p className="vio-field-error">
          Не удалось загрузить настройки ускорения детекций. Изменить их сейчас нельзя.
        </p>
      )}

      {enabled && (
        <div className="vio-rule-extra-fields">
          <div className="vio-field">
            <label className="vio-field-label" htmlFor={`${idPrefix}-boost-interval`}>
              Интервал ускоренной детекции, с
            </label>
            <input
              id={`${idPrefix}-boost-interval`}
              type="number"
              min="1"
              step="1"
              value={value.requestedIntervalSec}
              disabled={locked}
              onChange={(event) => onChange({ ...value, requestedIntervalSec: event.target.value })}
            />
          </div>
          <div className="vio-field">
            <label className="vio-field-label" htmlFor={`${idPrefix}-boost-release`}>
              Удержание ускорения после завершения нарушения, с
            </label>
            <input
              id={`${idPrefix}-boost-release`}
              type="number"
              min="0"
              max={BOOST_MAX_RELEASE_DELAY_SEC}
              step="1"
              value={value.releaseDelaySec}
              disabled={locked}
              onChange={(event) => onChange({ ...value, releaseDelaySec: event.target.value })}
            />
          </div>
        </div>
      )}
      {error && <p className="vio-field-error">{error}</p>}

      <CameraSamplingNow effective={effective} />
    </fieldset>
  );
};

export default SamplingBoostFields;
